import { cliente } from '@/lib/cliente';
import type { ActualizarCausa, CrearCausa } from '@adelante/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

export function useCausas() {
  return useQuery({
    queryKey: ['causas'],
    queryFn: () => cliente.causas.listar(),
  });
}

export function useCrearCausa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: CrearCausa) => cliente.causas.crear(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['causas'] }),
  });
}

export function useActualizarCausa() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: number; body: ActualizarCausa }) =>
      cliente.causas.actualizar(id, body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['causas'] }),
  });
}
